<template>
    <div class="dashboard_wrp">
        <dash-sidebar v-if="!isMobile"></dash-sidebar>
        <router-view></router-view>
        <tukivita v-if="!isMobile"></tukivita>
        <video-call v-if="incomingCallNotification" v-bind:callerInfo="callerInfo" v-bind:roomId="roomId"></video-call>
        <networkIssuePopup></networkIssuePopup>
    </div>
</template>

<script>
import DashSidebar from '@/components/private/common/dashboard-left-sidebar/'
import tukivita from '@/components/private/ai-chatbot/'
import networkIssuePopup from '@/components/common/network-issue-popup/'
import videoCallNotification from '@/components/private/video-call-notification-popup/'

import Push from 'push.js'
import commonSocket from '@/commonSocket'
import socketMixin from '@/mixins/socketMixin' // 👈 Import your new mixin
import { mapGetters } from 'vuex'
import { bus } from '@/main'

let schedulerPushNotification

export default {
  name: 'Dashboard',
  mixins: [socketMixin], // 👈 Register the mixin here

  components: {
    DashSidebar,
    tukivita: tukivita,
    VideoCall: videoCallNotification,
    NetworkIssuePopup: networkIssuePopup
  },

  data() {
    return {
      incomingCallNotification: false,
      isMobile: false,
      audioPlayer: null,
      roomId: '',
      callerInfo: null
    }
  },

  computed: {
    ...mapGetters(['selfUserInfoGetters']),
    userDetails() {
      const s = this.selfUserInfoGetters
      return s && s.data ? s.data : null
    }
  },

  created() {
    this.initApp()
  },

  mounted() {
    window.addEventListener('resize', this.onResize)
    window.addEventListener('beforeunload', this.closeSocket)
    this.onResize()
  },

  beforeDestroy() {
    this.cleanup()
  },

  beforeRouteLeave(to, from, next) {
    this.cleanup()
    next()
  },

  methods: {
    // ---------------- INIT ----------------
    initApp() {
      this.checkAuth()
      this.initUser()
      this.initPush()
      
      // Call initialization from Mixin
      this.initSocketLifecycle(this.selfUserId)
      
      this.registerBusEvents()

      document.body.classList.add('dashboard')
      document.body.classList.remove('videoNotificationPopup')
      
      this.$nextTick(() => { 
        bus.$emit('showHeaderbtn', true)
        this.$store.dispatch('loader/stopLoadingWithDelay')
      })
    },

    checkAuth() {
      if (!localStorage.getItem('token') || !localStorage.getItem('LoginedUserID')) {
        this.$router.push('/')
      }
    },

    initUser() {
      this.selfUserId = localStorage.getItem('LoginedUserID')
      this.$store.dispatch('getAuthHeader')
    },

    initPush() {
      Push.Permission.request(this.onGranted, this.onDenied)
    },

    // ---------------- BUS EVENTS ----------------
    registerBusEvents() {
      bus.$on('callerNotifiactionBus', this.onCallerNotification)
      bus.$on('sendRequestMessage', this.onSendRequest)
      bus.$on('newChatMessage', this.onNewChatMessage)
    },

    unregisterBusEvents() {
      bus.$off('callerNotifiactionBus', this.onCallerNotification)
      bus.$off('sendRequestMessage', this.onSendRequest)
      bus.$off('newChatMessage', this.onNewChatMessage)
    },

    onCallerNotification(val) {
      this.incomingCallNotification = val
    },

    onSendRequest(data) {
      commonSocket.emit({
        message: 'Friend Request',
        type: 'friendRequest',
        userID: data.to_user,
        fromUserID: data.from_user,
        second_user_id: data.to_user
      })
    },

    onNewChatMessage(data) {
      commonSocket.emit({
        type: 'newChatMessage',
        chatRoomId: data.chatRoomId,
        message: data.message,
        senderName: data.senderName,
        messageId: data.messageId
      })
    },

    // ---------------- PUSH NOTIFICATIONS ----------------
    showCallingPushNotification(data) {
      if (Push.Permission.get() !== 'granted') {
        Push.Permission.request()
        return
      }

      Push.create(`Video Call From ${data.callerName}`, {
        body: 'Tap to answer the video call',
        icon: window.location.origin + '/favicon.ico',
        timeout: 5000,
        silent: true,
        onClick: function () {
          window.focus()
          this.close()
        }
      })
    },

    // ---------------- UTILS ----------------
    onResize() {
      this.isMobile = window.innerWidth < 769
    },

    playSound(src) {
      if (!src) return
      this.stopSound()
      this.audioPlayer = new Audio(src)
      this.audioPlayer.play().catch(() => {})
    },

    stopSound() {
      if (!this.audioPlayer) return
      this.audioPlayer.pause()
      this.audioPlayer.currentTime = 0
      this.audioPlayer = null
    },

    cleanup() {
      this.stopSound()
      this.closeSocket() // Mixin's close method
      this.unregisterBusEvents()

      window.removeEventListener('resize', this.onResize)
      window.removeEventListener('beforeunload', this.closeSocket)

      document.body.classList.remove('dashboard', 'videoNotificationPopup')
      clearInterval(schedulerPushNotification)
    },

    onGranted() {},
    onDenied() {}
  }
}
</script>

<style lang="scss" scoped>
.dashboard_wrp {
    min-height: 100dvh;
    padding: 70px 10px 10px 120px;
    position: relative;
}

.dashboard_wrp .lymphomap_main {
    background: rgba(0, 0, 0, 0.6);
    border-radius: 3px;
    padding: 15px;
    min-height: calc(100dvh - 80px);
    position: relative;
    width: 100%;
    margin-left: auto;
}

.modal-backdrop {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1040;
    background-color: #000;
    opacity: .5;
}

.unsupported-browser {
    &.modal {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 1050;
        overflow: hidden;
        outline: 0;

        &.modal-open {
            overflow-x: hidden;
            overflow-y: auto;
            display: block;
        }

        .modal-dialog {
            position: relative;
            width: auto;
            margin: .5rem;
            pointer-events: none;

            @media (min-width: 576px) {
                max-width: 500px;
                margin: 1.75rem auto;
            }

            &.modal-dialog-centered {
                display: -webkit-box;
                display: -ms-flexbox;
                display: flex;
                -webkit-box-align: center;
                -ms-flex-align: center;
                align-items: center;
                min-height: calc(100% - (.5rem * 2));

                @media (min-width: 576px) {
                    min-height: calc(100% - (1.75rem * 2));
                }
            }

            .modal-content {
                position: relative;
                display: -webkit-box;
                display: -ms-flexbox;
                display: flex;
                -webkit-box-orient: vertical;
                -webkit-box-direction: normal;
                -ms-flex-direction: column;
                flex-direction: column;
                width: 100%;
                pointer-events: auto;
                background-color: #000000;
                background-clip: padding-box;
                border: 1px solid rgba(255, 255, 255, .2);
                border-radius: .3rem;
                outline: 0;
                box-shadow: -1px -1px 18px rgba(251, 247, 165, 0.3);

                .modal-body {
                    padding: 30px;

                    @media (max-width: 575px) {
                        padding: 15px;
                    }

                    h3 {
                        color: #fbf7a5;
                        font-weight: 600;
                        letter-spacing: 1px;

                        @media (max-width: 575px) {
                            font-size: 24px;
                        }
                    }

                    p {
                        letter-spacing: 1.3px;
                        color: #ffffff;
                        font-weight: 400;
                        font-size: 14px;
                        font-family: 'MyriadProRegular', 'Lato', sans-serif;
                        line-height: 1.7;

                        @media (max-width: 575px) {
                            font-size: 13px;
                        }
                    }

                    .btn {
                        background: #ffc800 !important;
                        border: none !important;
                        color: #000 !important;
                        -webkit-box-shadow: none !important;
                        box-shadow: none !important;
                        font-size: 14px;
                        font-weight: 600;
                        font-family: 'MyriadProRegular', 'Lato', sans-serif;
                        letter-spacing: 1px;

                        &:hover {
                            background: #87cefa !important;
                            color: #22292f !important;
                        }
                    }
                }
            }
        }
    }

    .browser-list {
        padding: 0;
        margin: 0 0 20px;
        list-style: none;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
        align-items: center;

        li {
            -webkit-box-flex: 0;
            -ms-flex: 0 0 33.33333%;
            flex: 0 0 33.33333%;
            max-width: 33.33333%;
            text-align: center;
            padding: 0px 4px;

            a {
                color: #ffd700;
                letter-spacing: 1.3px;
                font-size: 13px;

                @media (max-width: 575px) {
                    font-size: 9px;
                }
            }

            span {
                display: block;
                margin-top: 3px;
                font-size: 13px;
                color: #f2f2f2;
                font-family: 'MyriadProRegular', 'Lato', sans-serif;
                letter-spacing: 1px;

                @media (max-width: 575px) {
                    font-size: 11px;
                }
            }

            img {
                max-width: 60px;
                display: block;
                margin: 0 auto 15px;

                @media (max-width: 575px) {
                    max-width: 40px;
                }
            }
        }
    }
}

@media only screen and (max-width:767px) {
    .dashboard_wrp {
        padding: 70px 0px 10px;
    }
}
</style>